var warned = {};
export function warnOnce(message) {
  if (!warned[message]) {
    /* istanbul ignore else */
    if (typeof console !== 'undefined') {
      console.error(message); // eslint-disable-line no-console
    }

    warned[message] = true;
  }
}
export function deprecated(propType, explanation) {
  return function validate(props, propName, componentName) {
    if (props[propName] !== null && typeof props[propName] !== 'undefined') {
      warnOnce("\"".concat(propName, "\" property of \"").concat(componentName, "\" has been deprecated.\n").concat(explanation));
    }

    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    return propType.apply(void 0, [props, propName, componentName].concat(rest));
  };
}
/**
 * Returns a new object with the key/value pairs from `obj` that are not in the array `omitKeys`.
 */

export function omit(obj, omitKeys) {
  var result = {};
  Object.keys(obj).forEach(function (key) {
    if (omitKeys.indexOf(key) === -1) {
      // eslint-disable-next-line @typescript-eslint/no-extra-semi
      ;
      result[key] = obj[key];
    }
  });
  return result;
}
/**
 * Returns a filtered copy of an object with only the specified keys.
 */

export function pick(obj, keys) {
  var pickKeys = Array.isArray(keys) ? keys : [keys];
  var length = pickKeys.length;
  var key;
  var result = {};

  while (length > 0) {
    length -= 1;
    key = pickKeys[length];
    result[key] = obj[key];
  }

  return result;
}
export var getColumnSizeClass = function getColumnSizeClass(isXs, colWidth, colSize, styles) {
  if (colSize === true || colSize === '') {
    return isXs ? styles.col : styles["col-".concat(colWidth)];
  } else if (colSize === 'auto') {
    return isXs ? styles['col-auto'] : styles["col-".concat(colWidth, "-auto")];
  }

  return isXs ? styles["col-".concat(colSize)] : styles["col-".concat(colWidth, "-").concat(colSize)];
};
/**
 * Helper function to find option by value recursively
 */

export var findOptionByValue = function findOptionByValue(options, value) {
  var childrenKeyName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'options';
  var found = null;
  options.some(function (option) {
    if (option.value === value) {
      found = option;
    } else if (option[childrenKeyName] && option[childrenKeyName].length) {
      found = findOptionByValue(option[childrenKeyName], value, childrenKeyName);
    }

    if (found) {
      return true;
    }
  });
  return found;
};